import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useLegalClientRepresentativeSaveRoleInCompanyMutation } from 'api/generated/graphql';
import { useError } from 'api/helpers';
import { SaveRoleInCompanyParam } from 'api/types/params/onboarding/saveRoleInCompanyParam';

import { parseLegalClientRepresentative } from './helpers';
import { parseRoleInCompanyParam } from './helpers/parseRoleInCompanyParam';

export const useLegalClientRepresentativeSaveRoleInCompany = () => {
  const [handle, { data, loading, error: apolloError }] =
    useLegalClientRepresentativeSaveRoleInCompanyMutation();

  const error = useError(apolloError);

  return {
    data: data?.legalClientRepresentativeSaveRoleInCompany
      ? parseLegalClientRepresentative(
          data.legalClientRepresentativeSaveRoleInCompany
        )
      : undefined,
    loading,
    error,
    saveRoleInCompany: useCallback(
      async (id: string, params: SaveRoleInCompanyParam) => {
        const res = await handle({
          variables: {
            id,
            input: parseRoleInCompanyParam(params),
          },
        });
        return res?.data?.legalClientRepresentativeSaveRoleInCompany
          ? parseLegalClientRepresentative(
              res.data.legalClientRepresentativeSaveRoleInCompany
            )
          : undefined;
      },
      [handle]
    ),
  };
};
